<template lang="pug">
#enroll
  .container
    breadcrumb(v-bind:pageName="pageName")
    h4.text-center 課程報名表

    #accordion.mb-5.mt-3
      .news_card.mb-4.border-radius-10
        .row.align-items-center
          .col-6
            span.title.mt-0 請選擇報名課程
          .col-12.group.mt-4
            .radio_btn.flex_h(
              v-for="programProductGroup in programProductGroupList",
              :key="programProductGroup.id",
              v-if="!programProductGroup.is_additional"
            )
              label
                input(
                  type="radio",
                  name="product_group",
                  :value="programProductGroup",
                  v-model="programProductGroupSelect"
                )
                span {{ programProductGroup.name }}
        .row.mt-3(v-if="programProductGroupSelect.program_type == 'TYPE_CAMP'")
          .col-12.d-flex.justify-content-end
            label
              input(
                style="margin-left: 0",
                type="checkbox",
                v-model="isGroupEnroll"
              )
              span.group_enroll(:class="{ checked: isGroupEnroll }") 團體報名
        .row.mt-3(v-if="programProductGroupSelect != -1")
          .col-12.selector
            select.mt-2(name="courseType", v-model="courseTypeSelect")
              option(v-for="courseType in courseTypeList", :value="courseType") {{ courseType.name }}
            select.mt-2(name="district", v-model="districtSelect")
              option(value="") 請選擇區域
              option(v-for="district in districtList", :value="district") {{ district.name }}
            select.mt-2(name="court", v-model="courtSelect")
              option(value="") 請選擇場地
              option(v-for="court in courtList", :value="court") {{ court }}
        .row.mt-3(v-if="!isGroupEnroll")
          .col-12
            //---- checkbox--->
            .product_btn.checkbox(
              v-for="product in productList",
              :key="product.id"
            )
              .info_btn(
                @click="product.isExpand = !product.isExpand",
                :class="{ expand: product.isExpand }"
              )
                span.d-none.d-md-inline-block {{ product.isExpand ? '收合' : '詳細' }}
                font-awesome-icon.ml-1(:icon="['fas', 'chevron-right']") 
              label
                input(
                  type="checkbox",
                  name="product",
                  :value="product.id",
                  v-model="productCheckboxSelect"
                )
                .course_radio_btn
                  .course_title_wrapper.d-flex.align-items-center
                    .radio_circle
                    span.course_title {{ product.name }} (NT. {{ product.total_price }})
                  .course_content(v-if="product.isExpand")
                    p(v-for="spec in product.program_product_specs") {{ spec.name }}
                      span {{ spec.val }}
        .row.mt-3(v-if="isGroupEnroll")
          .col-12
            //---- radio--->
            .product_btn.radio_btn(
              v-for="product in productList",
              :key="product.id"
            )
              .info_btn(
                @click="product.isExpand = !product.isExpand",
                :class="{ expand: product.isExpand }"
              )
                span.d-none.d-md-inline-block {{ product.isExpand ? '收合' : '詳細' }}
                font-awesome-icon.ml-1(:icon="['fas', 'chevron-right']") 
              label
                input(
                  type="radio",
                  name="product",
                  :value="product.id",
                  v-model="productRadioSelect"
                )
                .course_radio_btn
                  .course_title_wrapper.d-flex.align-items-center
                    .radio_circle
                    span.course_title {{ product.name }} (NT. {{ product.total_price }})
                  .course_content(v-if="product.isExpand")
                    p(v-for="spec in product.program_product_specs") {{ spec.name }}
                      span {{ spec.val }}
  .container-fluid.bg-white.py-5(v-if="productCheckboxSelect.length > 0")
    .container
      .row(v-if="extraProductList.length != 0")
        .col-12.text-center
          h4 加購商品
          hr
      .row(v-if="extraProductList.length != 0")
        .col-md-4.product(
          v-for="(extraProduct, index) in extraProductList",
          :key="index"
        )
          product(:product="extraProduct", @extraChange="extraChange")
    .container
      .row.submit-btn.mt-3.justify-content-center
        .col-md-12.text-center
          .send_btn(@click="toEnrollInfo") 前往填寫個人資料
  custom-footer
  dialog-alert(
    v-if="alertDialogShow",
    :title="alertDialogTitle",
    :content="alertDialogContent"
  )
  custom-dialog-login(
    v-if="loginDialogShow",
    @closeLoginDialog="closeLoginDialog",
    @successBack="successBack",
    @sendEmailSuccessBack="sendEmailSuccessBack"
  )
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Product from "@/components/enroll/Product";
import Breadcrumb from "@/components/common/Breadcrumb";
import {
  getProgramProductGroupList,
  getProgramProductList,
} from "@/api/ecommerce";
import { stopScroll, startScroll } from "@/utils/scroll";
import DialogAlert from "@/components/login/DialogAlert";
import CustomDialogLogin from "@/components/login/CustomDialogLogin";
import {
  setOrderProgramProductGroupSelect,
  setOrderProductSelect,
  setOrderSelectExtraProducts,
  setIsGroupEnroll,
  removeOrderProgramProductGroupSelect,
  removeOrderProductSelect,
  removeOrderSelectExtraProducts,
  removeIsGroupEnroll,
} from "@/utils/auth";

export default {
  name: "Enroll",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
    product: Product,
    "dialog-alert": DialogAlert,
    "custom-dialog-login": CustomDialogLogin,
  },
  data() {
    return {
      pageName: "課程報名表",
      checkboxList: [],
      applyTypeSelect: -1,
      isGroupEnroll: false,
      programProductGroupList: [],
      programProductGroupSelect: -1,
      programProductGroup: [],
      programProductGroupSelectId: -1,
      courseTypeList: [],
      districtList: [],
      courtList: [],
      courseTypeSelect: {},
      districtSelect: "",
      courtSelect: "",
      productList: [],
      productCheckboxSelect: [],
      productRadioSelect: null,
      extraProductList: [],

      selectExtraProducts: [],

      tempProgram: this.$route.params.program,
      tempCourseType: this.$route.params.courseType,

      alertDialogShow: false,
      alertDialogTitle: "",
      alertDialogContent: "",
      loginDialogShow: false,

      isExpand: false,
    };
  },
  watch: {
    programProductGroupSelect() {
      this.isGroupEnroll = false;
      this.courseTypeList = this.programProductGroupSelect.query_infos;
      if (
        this.programProductGroupSelect.query_infos &&
        this.programProductGroupSelect.query_infos.length > 0
      ) {
        this.courseTypeSelect = this.programProductGroupSelect.query_infos[0];
      }

      this.productCheckboxSelect = [];
      this.getExtraProduct();
    },
    courseTypeSelect() {
      this.districtSelect = "";
      this.courtSelect = "";
      this.getProgramProductList();

      this.districtList = this.courseTypeSelect.districts;
    },
    districtSelect() {
      this.courtSelect = "";
      this.courtList = this.districtSelect.courts;
      this.getProgramProductList();
    },
    courtSelect() {
      this.getProgramProductList();
    },
    isGroupEnroll() {
      this.productCheckboxSelect = [];
      this.productRadioSelect = null;
    },
    productRadioSelect() {
      this.productCheckboxSelect = [];
      this.productCheckboxSelect.push(this.productRadioSelect);
    },
  },
  created() {
    this.getProgramProductGroupList();
  },
  methods: {
    toEnrollInfo() {
      if (!this.$store.state.user.accessToken) {
        this.alertDialogShow = true;
        this.alertDialogTitle = "提醒";
        this.alertDialogContent = "請先登入會員";
        setTimeout(() => {
          this.alertDialogShow = false;
          this.alertDialogTitle = "";
          this.alertDialogContent = "";
          this.openLoginDialog();
        }, 1500);
      } else {
        removeOrderProgramProductGroupSelect();
        removeOrderProductSelect();
        removeOrderSelectExtraProducts();
        removeIsGroupEnroll();
        setOrderProgramProductGroupSelect(this.programProductGroupSelect.id);
        setOrderProductSelect(this.productCheckboxSelect);
        setOrderSelectExtraProducts(this.selectExtraProducts);
        setIsGroupEnroll(this.isGroupEnroll);
        this.$router.push({
          name: "EnrollInfo",
        });
      }
    },
    getProgramProductGroupList() {
      getProgramProductGroupList().then((response) => {
        this.programProductGroupList = response.data;
      });
    },
    getProgramProductList() {
      this.productList = [];
      this.selectExtraProducts = [];
      let params = {};
      params.program_product_group = this.programProductGroupSelect.id;
      if ("TYPE_NORMAL" == this.programProductGroupSelect.program_type) {
        params.course_type_name = this.courseTypeSelect.name;
      } else if ("TYPE_CAMP" == this.programProductGroupSelect.program_type) {
        params.course_time_name = this.courseTypeSelect.name;
      }
      if (this.districtSelect != "") {
        params.district_name = this.districtSelect.name;
      }
      if (this.courtSelect != "") {
        params.court_name = this.courtSelect;
      }
      getProgramProductList(params).then((response) => {
        let tempList = response.data;
        for (let index in tempList) {
          let tempProduct = tempList[index];
          tempProduct.isExpand = false;
        }
        this.productList = tempList;
      });
    },
    getExtraProduct() {
      this.extraProductList = [];
      for (let index in this.programProductGroupList) {
        let temp = this.programProductGroupList[index];
        if (
          this.programProductGroupSelect.program == temp.program &&
          temp.is_additional
        ) {
          let params = {};
          params.program_product_group = temp.id;
          getProgramProductList(params).then((response) => {
            let tempProductList = response.data;
            for (let index in tempProductList) {
              let tempProduct = tempProductList[index];
              this.extraProductList.push(tempProduct);
            }
          });
        }
      }
    },
    extraChange(extraItem) {
      if (this.selectExtraProducts.includes(extraItem)) {
        this.selectExtraProducts.splice(
          this.selectExtraProducts.indexOf(extraItem),
          1
        );
      } else {
        this.selectExtraProducts.push(extraItem);
      }
    },
    openLoginDialog() {
      this.loginDialogShow = true;
      stopScroll();
    },
    closeLoginDialog() {
      this.loginDialogShow = false;
      startScroll();
    },
    successBack() {
      this.loginDialogShow = false;
      this.successDialogShow = true;
      this.successDialogTitle = "登入成功";
      this.successDialogContent = "您已成功登入會員";
      setTimeout(() => {
        this.successDialogShow = false;
        this.successDialogTitle = "";
        this.successDialogContent = "";
        startScroll();
      }, 1500);
    },
    sendEmailSuccessBack() {
      this.loginDialogShow = false;
      this.successDialogShow = true;
      this.successDialogTitle = "信件已寄出";
      this.successDialogContent = "請至信箱確認修改密碼的信件";
      setTimeout(() => {
        this.successDialogShow = false;
        this.successDialogTitle = "";
        this.successDialogContent = "";
        startScroll();
      }, 1500);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/enroll/enroll";
@import "@/assets/style/enroll/checkbox_btn_item";
</style>
